import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-white text-slate-900 relative overflow-hidden border-t border-slate-100">
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8 relative z-10">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-2">
              <img 
                src="https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/4c1594c5-9a06-4fbd-82c2-848fc278da5d.jpeg" 
                alt="HN Promotion Logo" 
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-sm leading-6 text-slate-600 max-w-xs">
              Din partner inden for profilbeklædning, sportstøj og firmagaver.
            </p>
            <div className="flex gap-x-4">
              <a href="#" className="text-slate-600 hover:text-orange-600 transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-slate-600 hover:text-orange-600 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-slate-600 hover:text-orange-600 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:col-span-2 xl:mt-0">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:col-span-2">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-[#1e335e] uppercase tracking-wider">Kategorier</h3>
                <ul role="list" className="mt-4 space-y-2">
                  <li><Link to="/kategori/profiltoej" className="text-sm leading-6 text-slate-600 hover:text-orange-600 transition-colors">Profiltøj</Link></li>
                  <li><Link to="/kategori/sportstoej" className="text-sm leading-6 text-slate-600 hover:text-orange-600 transition-colors">Sportstøj</Link></li>
                  <li><Link to="/kategori/padel" className="text-sm leading-6 text-slate-600 hover:text-orange-600 transition-colors">Padel</Link></li>
                  <li><Link to="/specialdesign" className="text-sm leading-6 text-slate-600 hover:text-orange-600 transition-colors">Specialdesign</Link></li>
                  <li><Link to="/kategori/arbejdstoej" className="text-sm leading-6 text-slate-600 hover:text-orange-600 transition-colors">Arbejdstøj</Link></li>
                  <li><Link to="/kategori/firmatoej" className="text-sm leading-6 text-slate-600 hover:text-orange-600 transition-colors">Firmatøj</Link></li>
                </ul>
              </div>
              <div>
                <h3 className="text-sm font-semibold leading-6 text-[#1e335e] uppercase tracking-wider">Virksomheden</h3>
                <ul role="list" className="mt-4 space-y-2">
                  <li><Link to="/showroom" className="text-sm leading-6 text-slate-600 hover:text-orange-600 transition-colors">Showroom</Link></li>
                  <li><Link to="/messesystemer" className="text-sm leading-6 text-slate-600 hover:text-orange-600 transition-colors">Messesystemer</Link></li>
                  <li><Link to="/anbefalinger" className="text-sm leading-6 text-slate-600 hover:text-orange-600 transition-colors">Anbefalinger</Link></li>
                  <li><a href="#" className="text-sm leading-6 text-slate-600 hover:text-orange-600 transition-colors">Om os</a></li>
                  <li><Link to="/kontakt" className="text-sm leading-6 text-slate-600 hover:text-orange-600 transition-colors">Kontakt</Link></li>
                </ul>
              </div>
            </div>
            <div className="flex flex-col justify-between">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-[#1e335e] uppercase tracking-wider">Kontakt os</h3>
                <ul role="list" className="mt-4 space-y-4">
                  <li className="flex items-center gap-3 text-sm text-slate-600">
                    <Phone className="h-4 w-4 text-slate-900" />
                    <a href="tel:+4551821153" className="hover:text-orange-600 transition-colors">+45 5182 1153</a>
                  </li>
                  <li className="flex items-center gap-3 text-sm text-slate-600">
                    <Mail className="h-4 w-4 text-slate-900" />
                    <a href="mailto:henrik@hnpromotion.dk" className="hover:text-orange-600 transition-colors">henrik@hnpromotion.dk</a>
                  </li>
                  <li className="flex items-center gap-3 text-sm text-slate-600">
                    <MapPin className="h-4 w-4 text-slate-900" />
                    <span>Algade 12, 4000 Roskilde</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-slate-200 pt-8">
          <p className="text-xs leading-5 text-slate-500">
            &copy; {new Date().getFullYear()} HN Promotion. Alle rettigheder forbeholdes.
          </p>
        </div>
      </div>
    </footer>
  );
}
